import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ModeOfPaymentProperties } from '../Models/ModeOfPaymentProperties';
@Injectable({
  providedIn: 'root'
})
export class ModeOfPaymentService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  getAllModeOfPayment(): Observable<ModeOfPaymentProperties[]> {
    return this.http.get<ModeOfPaymentProperties[]>(this.baseUrl + '/ModeOfPayment/GetAllModeOfPayment')
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  create(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ModeOfPayment/addNewModeOfPayment', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  getDepositTypeById(depositTypeId): Observable<ModeOfPaymentProperties> {
    //console.log(depositTypeId);
    return this.http.get<ModeOfPaymentProperties>(this.baseUrl + '/ModeOfPayment/GetModeOfPaymentById/' + depositTypeId)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }
  update(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/ModeOfPayment/updateModeOfPayment', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

}
